import { render, staticRenderFns } from "./QuickReplyMessage.vue?vue&type=template&id=fae3f2c6"
import script from "./QuickReplyMessage.vue?vue&type=script&lang=js"
export * from "./QuickReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyMessage.vue?vue&type=style&index=0&id=fae3f2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports